/**
 * @copyright       Palace Resorts
 * @description     Mensajes para la sección de inicio.
 * @author          Roberto Pérez Guzmán
 * @creationDate    06 de Mayo del 2021
 */

import _ from "lodash";
import appMessages from "@/i18n/app.messages";

let moduleMessages = {
    messages: {
        ESP: {
            lblTitle: "Bienvenido al Portal de Subcontratación",
            lblLoading: "Obteniendo la lista de empleados",
            //etiquetas de tabla de contenido vista HOME
            lblTableId: "NC",
            lblTableName: "Nombre empleado",
            lblTableUO: "U.O.",
            lblTableArea: "Área personal",
            lblTablePosition: "Función",
            lblTableUoName: "Descripción U.O.",
            //--lblTableSalary: "Salario",
            lblTableStatus: "Estado",
            lblTableAssesment: "Evaluación",
            lblTableFeedback: "Feedback",
            lblTableEvaluacion: "cierre de evaluación",
            lblTableActions: "Acciones",

            //--lblCheckSalario: "Mostrar salario",
            lblCheckRecursividad: "Mostrar subestructura",

            //--lblAssesment: "Evaluación",
            //--lblFeedback: "Feedback",
            lblSearch: "Buscar",
            lblNoData: "No existen empleados para la UO con las condiciones indicadas",
            //--lblFilterUser: "registros",
            lblFooterTable: "Registros por página",
            lblTotalRecords: "Registros totales",
            //--lblSearchHelp:"Introduzca un término de búsqueda para localizar a un empleado o grupo de empleados",
            lblDialogConfirmationTitle: "Cierre de evaluación",
            lblActionEvaluation: "Cerrar evaluación",
            lblActionEvaluation1: 'Abrir evaluación',

            lblAssesmentClosedMessage: "La evaluación del empleado <strong>{name}</strong> con número de control <strong>{controlNumber}</strong> ya se encuentra cerrada",
            lblAssesmentClosedMessage2: "Está a punto de cerrar la evaluación del empleado  <strong>{name}</strong> con número de control <strong>{controlNumber}</strong> ",
            lblAssesmentClosedMessage3: "Una vez realizada esta acción no podra modificarse.",
            lblAssesmentClosedMessage4: "¿Está seguro de cerrar la evaluación?",
            lblAssesmentClosedMessage5: 'Deseas abrir la evaluación?',
            lblAssesmentClosedMessage6: 'No se puede cerrar la evaluación del empleado <strong>{name}</strong> con número de control <strong>{controlNumber}</strong> por los siguientes puntos ',
            lblDashboard: 'Dashboard',


            welcome: 'Por favor elige el apartado con el que deseas interacturar.'
        },
        ENG: {
            lblTitle: "Welcome for the Outsourcing Portal",
            lblLoading: "Fetching employee list",

            lblCheckSalario: "Show salary",
            lblCheckRecursividad: "Show substructure",

            lblAssesment: "Assesment",
            lblFeedback: "Feedback",
            lblDelete: "Delete user",
            lblSearch: "Search",
            lblNoData: "No employees found for OU with conditions specified",
            lblFilterUser: "Records",
            lblFooterTable: "Records per page",

            lblDialogConfirmationTitle: "Evaluation closure",
            lblActionEvaluation: "Close evaluation",


            welcome: 'Please choose the section you want to interact with.'
        },
    },
};

export default _.merge(moduleMessages, appMessages);